var map = {
	"./bash": 2054,
	"./java": 2055,
	"./json": 2056,
	"./julia": 2057,
	"./python": 2058,
	"./r": 2059,
	"./rust": 2060,
	"./scala": 2061,
	"./shell": 2062,
	"./sql": 2063,
	"./xml": 2064,
	"./yaml": 2065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2053;